import { postStatusViewedURL } from "../../utils/ConstantsURL";

export const setNoteViewed = async (note_id, viewed, token) => {
  try {
    const response = await fetch(postStatusViewedURL(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ note_id, viewed }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      console.error("Error al marcar como visto:", data?.data?.message || "Error desconocido");
    }
  } catch (error) {
    console.error("Error al marcar como visto:", error);
  }
};
  